import { render, staticRenderFns } from "./AssetProfile.vue?vue&type=template&id=0bdeef42&"
import script from "./AssetProfile.vue?vue&type=script&lang=js&"
export * from "./AssetProfile.vue?vue&type=script&lang=js&"
import style0 from "./AssetProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports